// extracted by mini-css-extract-plugin
export var activeFilterButton = "_po-c";
export var backButton = "_po-4";
export var backIcon = "_po-5";
export var chevronShortcut = "_po-6";
export var container = "_po-1";
export var editor = "_po-8";
export var editorWrapper = "_po-7";
export var prefix = "_po-2";
export var searchIcon = "_po-3";
export var suffix = "_po-9";
export var suffixContent = "_po-a";
export var suffixText = "_po-b";
export var wrapper = "_po-0";